import dayjs from "dayjs";
import { getData, patchData, postData, putData } from "../../utils/serverHelper";
import { AUTOBOOK, BUSINESS, BUSINESS_PROFILE } from "../../utils/urls";
import { errorMessage, successMessage } from "../error/action";
import { setErrorTimings, setLoadingTimings, setSuccessTimings } from "./reducer";
import moment from "moment";
import { failedBusinessDetails, loadingBusiness, loadingBusinessDetails, successBusinessDetails } from "../business/reducer";

export const gettimings = async(dispatch,day)=>{
    try {
        dispatch(setLoadingTimings());
        const data = await getData('/business/get-openings?day='+day);
        dispatch(setSuccessTimings(data.data?.map((e)=>({...e,startTime:dayjs(moment(e.start_time,'HH:mm:ss').toISOString()),endTime:dayjs(moment(e.end_time,'HH:mm:ss').toISOString())}))));
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(setErrorTimings(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}

export const savetimings = async(dispatch,req)=>{
    try {
        dispatch(setLoadingTimings());
        await postData('/business/set-openings',req,);
        successMessage(dispatch,'Business timings updated successfully');
        await gettimings(dispatch,req.day);
        // dispatch(setSuccessTimings([{
        //     startTime:startTime,
        //     endTime:endTime,
        //     off,
            
        // }]));
        
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        // dispatch(setErrortimings(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}

export const updateProfile = async(dispatch,req,selector)=>{
    try {
        dispatch(loadingBusinessDetails());
        const data = await postData('/auth/v2/profile',req);
        dispatch(successBusinessDetails(selector));
        successMessage(dispatch,'Profile updated successfully');
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(failedBusinessDetails(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}

export const updateProfileOpen = async(dispatch,off,selector)=>{
    try {
        dispatch(loadingBusinessDetails());
        const data = await putData('/business',{
            'label':'off',
            'value':String(off)
        });
        dispatch(successBusinessDetails({...selector,off}));
        successMessage(dispatch,'Business availibility changed');
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(failedBusinessDetails(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}
export const autoBookOpen = async(dispatch,selector,off)=>{
    console.log(off,selector)
    
    try {
        dispatch(loadingBusinessDetails());
        await patchData(AUTOBOOK(selector),off)
        // dispatch(successBusinessDetails({...selector,off}));
        successMessage(dispatch,'AUTO BOOK ON/OFF');
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(failedBusinessDetails(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}

export const updateLabelProfile = async(dispatch,label,value,selector)=>{
    try {
        dispatch(loadingBusinessDetails());
        const data = await putData('/business',{
            'label':label,
            'value':value
        });
        dispatch(successBusinessDetails({...selector,[label]:value}));
        successMessage(dispatch,label+' is changed successfully');
    } catch (error) {
        errorMessage(dispatch,error?.response?.data?.error?.message || 'Server is down. Please try after some times');
        dispatch(failedBusinessDetails(error?.response?.data?.error?.message || 'Server is down. Please try after some times'));
    }
}

